module.exports = __webpack_public_path__ + "img/rank-top-img.53907c46.png";